import { TRANSITION_END } from '../../../utils/animation'
import '../../../plugins/bem'

export function replaceMeta(json_ld, json_meta) {
  /* Get page and image data */
  let page_data = false, image_data = false
  if (json_meta == undefined)  json_meta = {}
  json_ld['@graph'].forEach(function(data_element) {
    if ('@type' in data_element) {
      if (data_element['@type'] === 'WebPage') {
        page_data = data_element
      } else if (data_element['@type'] === 'ImageObject') {
        image_data = data_element
      }
    }
  })

  /* Replace JSON-LD script */
  $('head script[type="application/ld+json"].yoast-schema-graph').html(JSON.stringify(json_ld))

  /* Replace individual values */
  if (page_data) {
    $('head title').html(page_data.name)
    $('head meta[name="title"], head meta[property="og:title"]').attr('content', page_data.name)
    if ('description' in page_data) {
      $('head meta[name="description"], head meta[property="og:description"]').attr('content', page_data.description)
    } else if ('og:description' in json_meta && json_meta['og:description']) {
      $('head meta[name="description"], head meta[property="og:description"]').attr('content', json_meta['og:description'])
    }
    $('head meta[property="og:url"]').attr('content', page_data.url)
    if ('thumbnailUrl' in page_data) {
      $('head meta[property="og:image"]').attr('content', page_data.thumbnailUrl)
    } else if ('og:image' in json_meta && json_meta['og:image']) {
      $('head meta[property="og:image"]').attr('content', json_meta['og:image'])
    }
    $('head link[rel="canonical"]').attr('href', page_data.url)
    $('head meta[property*="modified_time"]').attr('content', page_data.dateModified)
  }
  if (image_data && 'url' in image_data) {
    $('head meta[property="og:image"]').attr('content', image_data.url)
    $('head meta[property="og:image:width"]').attr('content', image_data.width)
    $('head meta[property="og:image:height"]').attr('content', image_data.height)
    let image_type = 'image/jpeg';
    if (image_data.url.endsWith('.webp')) {
      image_type = 'image/webp';
    } else if (image_data.url.endsWith('.gif')) {
      image_type = 'image/gif';
    } else if (image_data.url.endsWith('.png')) {
      image_type = 'image/png';
    } else if (image_data.url.endsWith('.svg')) {
      image_type = 'image/svg+xml';
    }
    $('head meta[property="og:image:type"]').attr('content', image_type)
  }
  if ('canonical' in json_meta && json_meta.canonical) {
    $('head link[rel="canonical"]').attr('href', json_meta.canonical)
  }
  if ('href_langs' in json_meta) {
    for (let language_code in json_meta.href_langs) {
      $('head link[rel="alternate"][hreflang="' + language_code + '"]').attr('href', json_meta.href_langs[language_code])
    }
  }
}

/*
* Navigation
*/
export default function (options) {

  /*
  *	Properties
  */
  let obj = this
  this.currentURL = undefined
  this.currentContent = undefined
  this.isLoading = false
  this.isPopping = false
  this.request = undefined
  this.step = 0
  this.stepIncrement = 0

  if (options == undefined) {
    options = {}
  }

  /*
  * Options
  */
  this.options = $.extend(true, {
    init: true,
    useTransition: true,
    useEvents: true,
    useHistory: true,
    autoReplaceState: true,
    minTransitionTime: 0,
    selectors: {
      pageTransition: '.page-transition',
      pageContent: '.app',
      pageTarget: '.app',
      links: 'a[target!="_blank"]',
    },
    on: {
      beforeRegisterLinks: undefined,
      linkClicked: undefined,
      popState: undefined,
    },
    filter: {
      popState: undefined,
    }
  }, options)

  /*
  * Elements
  */
  this.el = {
    pageTransition: (this.options.useTransition) ? $(this.options.selectors.pageTransition).BlockElement() : undefined,
    pageTarget: $(this.options.selectors.pageTarget),
  }

  /*
  * Increment + getter
  */
  this.getStepIncrement = function() {
    obj.stepIncrement = ++obj.step
    return obj.stepIncrement
  }

  /*
  * Abort current request
  */
  this.abortRequest = function() {
    if (obj.request != undefined) {
      obj.request.abort()
      obj.request = undefined
    }
  }

  /*
  * Replace metadata from JSON-LD
  */
  this.replaceMeta = function(json_ld, json_meta) {
    replaceMeta(json_ld, json_meta)
  }

  /*
  * Get default pop state
  */
  this.getStateObject = function(properties, incrementStep) {
    if (incrementStep == undefined) {
      incrementStep = true
    }
    let stateObject = {
      isPageTransition: true,
      previousPageURL: window.location.href,
      stepIncrement: incrementStep ? obj.getStepIncrement() : obj.step,
    }
    if (properties != undefined) {
      stateObject = $.extend(true, stateObject, properties)
    }
    return stateObject
  }

  /*
  * Centralize pushState calls with filter
  */
  this.pushState = function(stateObject, documentTitle, documentURL) {
    if (location.hostname == 'localhost') {
      return
    }
    obj.currentURL = documentURL
    if (obj.options.filter.popState != undefined) {
      stateObject = obj.options.filter.popState(stateObject, 'pushState')
    }
    if (obj.options.useHistory) {
      window.history.pushState(stateObject, documentTitle, documentURL)
    }
  }

  /*
  * Centralize replaceState calls
  */
  this.replaceState = function(stateObject, documentTitle, documentURL) {
    if (location.hostname == 'localhost') {
      return
    }
    if (documentTitle == undefined) {
      documentTitle = document.title
    }
    if (documentURL == undefined) {
      documentURL = window.location.href
    }
    if (obj.options.filter.popState != undefined) {
      stateObject = obj.options.filter.popState(stateObject, 'replaceState')
    }
    window.history.replaceState(stateObject, documentTitle, documentURL)
  }

  /*
  *	Page display
  */
  this.pageDisplay = function(targetURL, loadedContent) {
    // Display loaded page
    let response = $('<html>').html(loadedContent)
    if (obj.el.pageTarget != undefined) {
      obj.el.pageTarget.replaceWith($(obj.options.selectors.pageContent, response))
      obj.el.pageTarget = $(obj.options.selectors.pageTarget)
    }
    requestAnimationFrame(function() {
      if (targetURL == obj.currentURL) {
        if (obj.options.useEvents) {
          $(window).trigger('page_load', [loadedContent])
        }
        obj.isLoading = false
        obj.registerLinks()
      }

      // Remove transition
      if (obj.options.useTransition) {
        obj.el.pageTransition.off(TRANSITION_END)
        requestAnimationFrame(function() {
          obj.el.pageTransition.addModifier('hidden').on(TRANSITION_END, function() {
            obj.el.pageTransition.off(TRANSITION_END).removeModifier('visible').removeModifier('hidden')
            if (obj.options.useEvents) {
              $(window).trigger('page_transition_ended')
            }
          })
        })
      }
    })

    // Push state
    if (!obj.isPopping) {
      document.title = $('title', response).text()
      $('head meta[name="title"]').attr('content', document.title)
      let popState = obj.getStateObject({}, true)
      obj.currentContent = response
      obj.pushState(popState, $('title', response).text(), obj.currentURL)
    }

    // Analytics called (probably not needed anymore)
    if ('gtag' in window && 'gtagid' in window) {
      gtag('config', window.gtagid, {
        'page_location': obj.currentURL,
      })
    }
    obj.isPopping = false
  }

  /*
  *	Page transition
  */
  this.getPage = function(href, callback) {
    // Keep current URL
    obj.currentURL = href

    // Default callback
    if (callback == undefined) {
      callback = obj.pageDisplay
      obj.isUsingCustomCallback = true
    } else {
      obj.isUsingCustomCallback = false
    }

    // Setting variables
    let targetURL = href,
    loadedContent = undefined,
    pageHasDisappeared = false,
    contentHasLoaded = false

    // Cancel request
    obj.abortRequest()

    // Show page transition
    obj.isLoading = true
    if (obj.options.useTransition) {
      if (obj.el.pageTransition.hasModifier('visible') && !obj.el.pageTransition.hasModifier('hidden')) {
        pageHasDisappeared = true
      } else {
        obj.el.pageTransition.off(TRANSITION_END)
        requestAnimationFrame(function() {
          obj.el.pageTransition.removeModifier('hidden')
          requestAnimationFrame(function() {
            obj.el.pageTransition.addModifier('visible').on(TRANSITION_END, function(e) {
              if (obj.options.minTransitionTime && e.originalEvent.elapsedTime < obj.options.minTransitionTime) {
                return
              }
              $(this).off(TRANSITION_END)
              if (obj.options.useEvents) {
                $(window).trigger('page_exit')
              }
              pageHasDisappeared = true
              if (contentHasLoaded) {
                callback(targetURL, loadedContent)
              }
            })
          })
        })
      }
      obj.request = $.get(targetURL, {}, function(x) {
        loadedContent = x
        contentHasLoaded = true
        if (pageHasDisappeared) {
          callback(targetURL, loadedContent)
        }
        obj.request = undefined
      }, 'html').fail(function(x) {
        if (x.status == 404) {
          loadedContent = x.responseText
          contentHasLoaded = true
          if (pageHasDisappeared) {
            callback(targetURL, loadedContent)
          }
        }
      })
    } else {
      if (obj.options.useEvents) {
        $(window).trigger('page_exit')
      }
      obj.request = $.get(targetURL, {}, function(x) {
        loadedContent = x
        callback(targetURL, loadedContent)
        obj.request = undefined
      }, 'html').fail(function(x) {
        if (x.status == 404) {
          loadedContent = x.responseText
          callback(targetURL, loadedContent)
        }
      })
    }
  }

  /*
  * Register links
  */
  this.registerLinks = function() {
    if (obj.options.on.beforeRegisterLinks != undefined) {
      obj.options.on.beforeRegisterLinks(this)
    }
    if (obj.options.selectors.links) {
      $(obj.options.selectors.links).each(function() {
        if (!$(this).data('registeredTransitionLink')) {
          $(this).data('registeredTransitionLink', 1)
          if ($(this).attr('href') && $(this).attr('href').substr(0, 4) == 'http' && $(this).attr('href').indexOf(window.location.hostname) === -1) {
            $(this).attr('target', '_blank')
          }
          $(this).on('click', function(e) {
            if ($(this).attr('target') === '_blank') {
              return true
            }
            if ($(this).data('preventTransition') === 1 || $(this).data('prevent-transition') === 1) {
              return true
            }
            if (e.originalEvent != undefined && (e.originalEvent.cmdKey || e.originalEvent.metaKey)) { return true }
            let link = $(this).attr('href')
            if (link) {
              if (link.substr(0,7) === 'mailto:') { return true }
              if (link.substr(0,4) === 'tel:') { return true }
              if (link === '#') { return false }
              let ext = link.substr(link.lastIndexOf('.') + 1)
              if (ext) {
                if (['pdf', 'jpg', 'gif', 'png', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'txt', 'xml'].indexOf(ext) !== -1) { return true }
              }
              if (obj.options.on.linkClicked != undefined) {
                let linkClicked = obj.options.on.linkClicked($(this))
                if (linkClicked === -1) {
                  return true
                } else if (linkClicked === -2) {
                  return false
                }
              }
              obj.getPage(link)
              return false
            }
          })
        }
      })
    }
  }

  /*
  * Initializer
  */
  this.init = function() {
    /* Pop state (back) */
    if (obj.options.useHistory) {
      $(window).on('popstate', function(e) {
        let popState = e.originalEvent.state
        if (popState != null) {
          popState.direction = popState.stepIncrement < obj.stepIncrement ? 'backward' : 'forward'
          obj.stepIncrement = popState.stepIncrement
          let popReturn = true
          if (obj.options.on.popState != undefined) {
            popReturn = obj.options.on.popState(e.target.location.href, popState)
          }
          if (obj.options.filter.popState != undefined) {
            popState = obj.options.filter.popState(popState, 'popState')
          }
          if (popReturn === true && popState.isPageTransition != null && popState.isPageTransition === true) {
            obj.isPopping = true
            obj.getPage(e.target.location.href)
          } else if (popState.isPageTransition != null && popState.isPageTransition === false) {
            if (popReturn === false) {
              e.preventDefault()
              return false
            } else {
              location.href = e.target.location.href
              return true
            }
          }
        }
      })

      /* Replace initial state (load) */
      if (!obj.el.pageTarget.data('no-transition') && obj.options.autoReplaceState) {
        let popState = obj.getStateObject({}, false)
        obj.replaceState(popState, document.title, window.location.href)
      }
    }

    /* First page load */
    if (obj.options.useEvents) {
      $(window).trigger('page_load')
    }

    /* Register links */
    obj.registerLinks()
  }

  /* Initialize and/or return */
  if (obj.options.init === true) {
    obj.init()
  }
  return obj
}
